import { useLocation } from 'react-router';

export const useQueryString = () => {
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const pageOrNull = params.get('page');
  const page = pageOrNull ? parseInt(pageOrNull, 10) : 1;

  return { page };
};
